import React, { useContext, useEffect, useState } from 'react'
import logo from '../../../logo.svg';
import { useNavigate } from 'react-router';
import { MdOutlineChat, MdOutlineNotifications } from "react-icons/md";
import { IoSearchOutline } from "react-icons/io5";
import { Link, useLocation } from 'react-router-dom';
import { Button ,ButtonGroup, Dropdown, NavDropdown } from 'react-bootstrap';
import moment from 'moment/moment';
import { getNotificationListing, markAsReadNotification } from '../../../api/context/notifications';

import { SelectionContext } from '../../../Context/Store';
import { LuUser } from "react-icons/lu";
import { FaUsers } from 'react-icons/fa';

const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();
  
    
    const user = JSON.parse(localStorage.getItem('user'));

    const { ordersTrigger, setOrdersTrigger } = useContext(SelectionContext)
    const { notifications, setNotifications } = useContext(SelectionContext)
    const { updateCount, setUpdateCount } = useContext(SelectionContext)

    const [loading, setLoading] = useState(false);
    const [isLaptop, setIsLaptop] = useState(false);
    // const [notifications, setNotifications] = useState([]);

    const [dataCount, setDataCount] = useState();
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 5;

    const handleLogout = () => {
        localStorage.clear();
        navigate('/login')
    }


    useEffect(() => {
        const handleResize = () => {
            const viewPort = window.innerWidth;
            setIsLaptop(viewPort > 991);
        };
        // Call once to set initial value
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const getNotifications = (page, limit) => {
        setLoading(true);
        getNotificationListing({ page, limit })((response) => {
            if (response?.statusCode === 200) {
                setNotifications(response?.data);
                setDataCount(response?.totalItems);
                setUpdateCount(response?.unreadCount)
            } else {
                console.error("Failed to fetch notifications");
            }
            setLoading(false);
        });
    };

    useEffect(() => {
        getNotifications(1, itemsPerPage);
    }, []);

    const onClickmarkAsRead = (notification) => {
        const id = Number(notification?.typeId);

        // Mark as read and refresh the notification list
        markAsReadNotification(id)((response) => {
            if (response?.status) {
                getNotifications(1, itemsPerPage); // Fetch updated notifications
            }
        });

        // Dynamic navigation with state
        switch (notification?.type) {
            case "order":
                navigate("/orderdetails/" + notification?.typeId, {
                    state: { notificationId: notification?.id },
                });
                break;
            case "chat":
                navigate("/chat-support", {
                    state: { chatId: notification?.typeId },
                });
                break;

            default:
                console.warn("No notification type");
        }
    };


    // useEffect(() => {
    //     if (initials) {
    //         const interval = setInterval(() => {
    //             requestForToken();
    //         }, 5 * 60 * 1000);

    //         return () => clearInterval(interval);
    //     } else {
    //         setInitials(true);
    //         requestForToken();
    //     }
    // }, []);

    if (user?.userType === 'Vendor' || user?.userType === 'ADMIN') {
        return null;
    }

    return (
        <>
        <style>{`
          #page-topbar {
            box-shadow: none !important;
          }
        `}</style>
        <header id="page-topbar">
            <div className="layout-width">
                <div className="navbar-header">

                    <div className='flex_wrapper'>
                        {/* <div className="title_header">
                            <h4 className="mb-sm-0">Dashboard</h4>
                        </div> */}
                        <div className='form_wrapper'>
                            {/* <form className="app-search d-none d-md-block">
                                <div className="position-relative">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search..."
                                        autoComplete="off"
                                        id="search-options"
                                        defaultValue=""
                                    />
                                    <span className="mdi mdi-magnify search-widget-icon" />
                                    <span
                                        className="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none"
                                        id="search-close-options"
                                    />
                                    <IoSearchOutline className='search_icon' />

                                </div>
                            </form> */}
                            {isLaptop === false &&
                                <Link className={`${location.pathname === '/my-profile' ? 'active' : ''}`} to='/my-profile'>
                                    <div className='d-flex align-items-center wrapper-notification'>
                                        <div className='notification-wrapper'>
                                            <button className='btn-outline-secondary border-0' type="button" onClick={() => navigate('/my-profile')}>
                                                <span className='notification'>
                                                    <LuUser />
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </Link>
                            }

                            {user?.userType !== "customerSupport" &&
                                <div className="d-flex align-items-center wrapper-notification">
                                    <div className='notification-wrapper'>
                                        <button className="btn-outline-secondary border-0" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            <span className='notification'>
                                                <MdOutlineNotifications />
                                                {updateCount > 0 && (
                                                    <span className='rounded-circle rounded-notification'></span>
                                                )}
                                            </span>
                                        </button>
                                        <ul className="dropdown-menu dropdown-menu-arrow notifications border-0">
                                            <p className='noti'>Notifications</p>
                                            {notifications?.map((notification, index) => (
                                                <div key={index}>
                                                    {notification?.status == "read" ?
                                                        <li className="notification-item read-notification">
                                                            <Button
                                                                className="p-0"
                                                                onClick={() => onClickmarkAsRead(notification)}
                                                            >
                                                                {/* <div className={notification?.is_read ? 'wrap-notification-content-read' : 'wrap-notification-content-unread'}> */}
                                                                <div className="wrap-notification-content">

                                                                    <div>
                                                                        {notification?.status == "read" ? (
                                                                            <h4 className="">
                                                                                {notification?.title}
                                                                            </h4>
                                                                        ) : (
                                                                            <h4 className="">
                                                                                {notification?.title}
                                                                            </h4>
                                                                        )}
                                                                        <div className="wrap-notification-content-btm">
                                                                            <p>
                                                                                {moment(notification?.createdAt).format(
                                                                                    "lll"
                                                                                )}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Button>

                                                        </li>
                                                        :
                                                        <li className="notification-item unread-notification">
                                                            <Button
                                                                className="p-0"
                                                                onClick={() => onClickmarkAsRead(notification)}
                                                            >
                                                                {/* <div className={notification?.is_read ? 'wrap-notification-content-read' : 'wrap-notification-content-unread'}> */}
                                                                <div className="wrap-notification-content_read">

                                                                    <div>
                                                                        {notification?.status == "read" ? (
                                                                            <h4 className="">
                                                                                {notification?.title}
                                                                            </h4>
                                                                        ) : (
                                                                            <h4 className="">
                                                                                {notification?.title}
                                                                            </h4>
                                                                        )}
                                                                        <div className="wrap-notification-content_read-btm">
                                                                            <p>
                                                                                {moment(notification?.created_date).format(
                                                                                    "lll"
                                                                                )}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Button>

                                                        </li>
                                                    }
                                                </div>
                                            ))}
                                            <li className="notification-item-bottom">
                                                <div className='wrap-notification-content-notifi'>
                                                    <Link className='' to='/view-notifications'>
                                                        <h5 className='view-notifi'>View All Notifications</h5>
                                                    </Link>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            }
                            
                            {user?.userType == "ADMIN" &&
                                <div className='d-flex align-items-center wrapper-notification'>
                                    <div className='notification-wrapper'>
                                        <button className='btn-outline-secondary border-0' type="button" onClick={() => navigate('/chat-support')}>
                                            <span className='notification'>
                                                <MdOutlineChat fontSize={18} />
                                            </span>
                                        </button>
                                    </div>
                                </div>
                            }

                        {isLaptop === false &&
                                  <div className='d-flex align-items-center wrapper-notification user-setup-dropdown-container'>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="outline-secondary" className="border-0" id="dropdown-users">
                                                <span className='setup-user-dropdown'>
                                                    <FaUsers fontSize={18} />
                                                </span>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item as={Link} to="/users">
                                                    Users
                                                </Dropdown.Item>
                                                <Dropdown.Item as={Link} to="/roles">
                                                    Roles
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </header>
        </>
    )
}

export default Header